import React, { useState } from "react";
import { Link } from "react-router-dom";

import Icon from "../Icon";
import Item from "./Item";

export const Group = ({ group, config = {}, itemTo }) => {
    // Fechado por padrão: com tudo recolhido a coluna cabe inteira na tela e
    // o cabeçalho de cada grupo já entrega contagem e alerta.
    const [open, setOpen] = useState(config.defaultOpen === true);

    const hasMore = group.count > group.items.length;

    return (
        <section className={`linked-group ${open ? 'is-open' : ''}`}>
            <button type="button" className="linked-group-head" onClick={() => setOpen(!open)}>
                <Icon name={config.icon ?? 'link'} size={15} />
                <span className="linked-group-name">{group.label}</span>
                {group.count > 0 && (
                    <span className={`linked-badge ${group.alert > 0 ? 'alert' : ''}`}>{group.count}</span>
                )}
                <Icon className="linked-chevron" name="arrow-dropdown" size={14} />
            </button>

            {open && (
                <div className="linked-group-items">
                    {group.items.map(item => (
                        <Item key={item.id} item={item} to={itemTo?.(item, group)} />
                    ))}

                    {group.empty_message && (
                        <p className="linked-empty">
                            {group.empty_message}
                            {config.emptyAction && (
                                <> <Link to={config.emptyAction.to}>{config.emptyAction.label}</Link></>
                            )}
                        </p>
                    )}

                    {hasMore && config.listTo && (
                        <Link className="linked-see-all" to={config.listTo}>
                            Ver todos ({group.count})
                        </Link>
                    )}
                </div>
            )}
        </section>
    );
}

export default Group;
